var _ = require('underscore');
var Backbone = require('backbone');
var API = EY.Consultation.Lookups.API.Consultation;
var GeographyAPI = EY.Consultation.Lookups.API.Geography;
var Labels = EY.Consultation.Labels;
var NpoAPI = EY.Consultation.Lookups.API.Npo;
var GclAPI = EY.Consultation.Lookups.API.Gcl;
var SolrAPI = EY.Consultation.Lookups.API.Solr;

var Hierarchy = Backbone.Model.extend({
    defaults: {
        parentId: '',
        path: '',
        text: '',
        type: '',
        typePath: ''
    }
});

module.exports.AccessControlEntry = Backbone.Model.extend({
    defaults: {
        permission: '',
        roleId: '',
        uri: ''
    },
    urlRoot: API + 'AccessControl'
});

module.exports.AccessControlList = Backbone.Collection.extend({
    model: module.exports.AccessControlEntry,
    url: API + 'AccessControl'
});

module.exports.Approver = Backbone.Model.extend({
    defaults: {
        acknowledgeStatus: '',
        acknowledgeDate: '',
        approval: '',
        approvalNotRequired: '',
        approverGroupId: '',
        comments: '',
        geographyId: '//',
        givenName: '',
        gpn: '',
        independence: '',
        order: -1,
        rank: '',
        recusal: '',
        upn: ''        
    },
    validation: {
        givenName: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Name) },
        rank: function () { return this.get('rank') === '' ? '' : (this.get('upn') && !this.get('rank') ? Labels.ErrorMsg.replace('{0}', Labels['ApproverGroup_' + this.get('approverGroupId') + '_RankLabel']) : ''); }
    }
});

module.exports.Approvers = Backbone.Collection.extend({
    comparator: 'order',
    model: module.exports.Approver
});

module.exports.ApproverGroup = Backbone.Model.extend({
    defaults: {
        configurable: false,
        lookup: false,
        multiple: false,
        order: -1,
        picklist: false,
        rank: false,
        required: true,
        roleId: '',
        visible: true
    },
    urlRoot: API + 'ApproverGroup'
});

module.exports.ApproverGroups = Backbone.Collection.extend({
    comparator: 'order',
    model: module.exports.ApproverGroup,
    url: API + 'ApproverGroup'
});

module.exports.Attachment = Backbone.Model.extend({
    defaults: {
        comments: '',
        date: '',
        filename: '',
        hasComments: false,
        hasTrackChanges: false,
        size: '',
        zone: 'consultation'
    },
    urlRoot: API + 'Attachment'
});

module.exports.Attachments = Backbone.Collection.extend({
    model: module.exports.Attachment,
    url: API + 'Attachment'
});

module.exports.Activity = Backbone.Model.extend({
    defaults: {
        date: new Date(),
        givenName: '',
        role: '',
        order: -1,
        text: ''
    },
    urlRoot: API + 'Activity'
})
module.exports.Activities = Backbone.Collection.extend({
    comparator: 'order',
    model: module.exports.Activity,
    url: API + 'Activity'
});

module.exports.ClassificationAudit = Backbone.Model.extend({
    defaults: {
        classificationId: '',
        oldText: '',
        newText: ''
    },
    urlRoot: API + 'ClassificationAudit'
});

module.exports.ClassificationAudits = Backbone.Collection.extend({
    model: module.exports.ClassificationAudit,
    url: API + 'ClassificationAudit'
});

module.exports.Classification = Hierarchy.extend({
    defaults: {
        _id: '',
        parentId: '',
        text: '',
        type: '',
        typePath: ''
    },
    urlRoot: API + 'Classification'
});

module.exports.Classifications = Backbone.Collection.extend({
    comparator: 'text',
    model: module.exports.Classification,
    url: API + 'Classification'
});

module.exports.CustomField = Backbone.Model.extend({
    defaults: {
        answer: '',
        name: '',
        order: -1,
        required: true,
        customFieldTypeId: 'CustomFieldType_Text'
    },
    validation: {
        answer: function (value) {
            return (this.get('customFieldTypeId') === 'CustomFieldType_Dropdown' && !!_.findWhere(value, { selected: true })) ||
                (this.get('customFieldTypeId') !== 'CustomFieldType_Dropdown' && value.toString().trim() !== '')
                ? '' : Labels.ErrorMsg.replace('{0}', Labels.Answer);
        },
        name: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Label) }
    }
});

module.exports.CustomFields = Backbone.Collection.extend({
    comparator: 'order',
    model: module.exports.CustomField
});

module.exports.Engagement = Backbone.Model.extend({
    defaults: {
        ClientId: '',
        ClientName: '',
        EngagementId: '',
        EngagementName: ''
    }
});

module.exports.Engagements = Backbone.Collection.extend({
    model: module.exports.Engagement,
    parse: function (response) {
        return response.value;
    },
    sync: function () {
        return Backbone.sync.apply(this, arguments);
    }
});

module.exports.Enumeration = Backbone.Model.extend({
    defaults: {
        order: -1,
        type: ''
    },
    urlRoot: API + 'Enumeration'
});

module.exports.Enumerations = Backbone.Collection.extend({
    comparator: 'order',
    model: module.exports.Enumeration,
    url: API + 'Enumeration'
});

module.exports.ExportUser = Backbone.Model.extend({
    idAttribute: "blank",
    urlRoot: API + 'User'
});

module.exports.ExportUsers = Backbone.Collection.extend({
    model: module.exports.ExportUser,
    url: API + 'User'
});

module.exports.GclRecord = Backbone.Model.extend({
    urlRoot: GclAPI + 'Record'
});

module.exports.GclRecords = Backbone.Collection.extend({
    comparator: 'text',
    model: module.exports.GclRecord,
    url: GclAPI + 'Record'
});

module.exports.Geography = Hierarchy.extend({
    urlRoot: GeographyAPI + 'Geography'
});

module.exports.Geographies = Backbone.Collection.extend({
    comparator: 'text',
    model: module.exports.Geography,
    url: GeographyAPI + 'Geography'
});

module.exports.NpoRecord = Backbone.Model.extend({
    urlRoot: NpoAPI + 'Record'
});

module.exports.NpoRecords = Backbone.Collection.extend({
    comparator: 'text',
    model: module.exports.NpoRecord,
    url: NpoAPI + 'Record'
});

module.exports.Query = Backbone.Model.extend({
    defaults: {
        aggregate: {},
        count: 0,
        filter: {},
        select: {},
        selected: false,
        type: ''
    }
});

module.exports.Queries = Backbone.Collection.extend({
    model: module.exports.Query
});

module.exports.Question = Backbone.Model.extend({
    defaults: {
        answer: '',
        order: -1,
        questionTypeId: 'QuestionType_Text',
        visible: true
    },
    urlRoot: API + 'Question'
});

module.exports.Questions = Backbone.Collection.extend({
    model: module.exports.Question,
    url: API + 'Question'
});

module.exports.Questionnaire = Backbone.Model.extend({
    defaults: {
        answers: [], // [Questions].
        approvers: [], // [ApproverGroups].
        fields: [], // [CustomFields].
        geographyId: '//',
        recordTypeId: 'RecordType_Consultation'
    },
    urlRoot: API + 'Questionnaire'
});

module.exports.Questionnaires = Backbone.Collection.extend({
    model: module.exports.Questionnaire,
    url: API + 'Questionnaire'
});

module.exports.Record = Backbone.Model.extend({
    defaults: {
        accountingStandard: '',
        activities: [],
        approvalBy: '',
        approvers: [],
        approverGroupId: '',
        assignedTo: '',
        assignedToApproverGroupId: '', // To capture the approverGroupId when is user is deactivated or user role is deleted manually
        assignedToGivenName: '',
        attachments: [],
        auditClient: true,
        clientId: '',
        clientName: '',
        closeMonitoring: false,
        communication: '',
        completedOn: '',
        configuration: {},
        countryId: '//',
        createdBy: '',
        createdOn: '',
        creatorGivenName: '',
        creatorGPN: '',
        description: '',
        discussed: false,
        engagementId: '',
        engagementName: '',
        engagementValidated: false,
        expiryAt: new Date(),
        fields: '',
        fiscalYearEnd: '',
        geographyId: '//',
        geographyTypePath: '',
        industryId: '',
        link: '',
        listedEntity: false,
        lockedBy: '',
        lockedByGivenName: '',
        lockedOn: '',
        modifiedBy: '',
        modifiedOn: '',
        nonListedPie: false,
        partner: '',
        questionnaireId: '',
        recordTypeId: '',
        restricted: false,
        secRegistrant: false,
        statusResourceKey: '',
        statusTypeId: 'StatusType_Blank',
        subjectDescription: '',
        subjectId: '',
        subject: '',
        subtypeId: '',
        subtype: '',
        typeId: '',
        type: '',
        topics:"",
        validChecksum: true,
        validateEngagement: true,
        zone: 'global',
        zoneKey: 0,
        location: '',
        displayAccountingstandard:false,
        isOpenedByCurrentUser: false
    },
    get:function(attr){
        var base = function (obj, attr) {
            return Backbone.Model.prototype.get.call(obj, attr);
        };
        if(attr === 'shortId') {
            if(new Date(this.attributes['createdOn']) > new Date(EY.Consultation.Lookups.Configuration.ShortIdStartDate)){
                return base(this,'id') ? base(this,'id').slice(-6) : '';
            }
            return base(this, 'id');
        }
        return base(this, attr);
    },
    urlRoot: API + 'Record',
    validation: {
        approvalBy: function (value) { return this.get('configuration').DisplayApprovalNeededBy && value === '' ? (Labels.ErrorMsg.replace('{0}', Labels.ApprovalNeededBy)) : ''; },
        clientId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.ClientCode) },
        clientName: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.ClientName) },
        discussed: function (value) { return this.get('configuration').DisplayCreatorAcknowledgement && !value ? Labels.PleaseAcknowledge : ''; },
        engagementId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.EngagementNumber) },
        engagementName: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.EngagementName) },
        fiscalYearEnd: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.FiscalYearEnd) },
        industryId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Industry) },
        recordTypeId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.RecordType) },
        subjectDescription: function (value) { return this.get('configuration').DisplaySubjectDescription && value.trim() === '' ? Labels.ErrorMsg.replace('{0}', Labels.SubjectDescription) : ''; },
        subjectId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Subject) },
        subtypeId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Subtype) },
        typeId: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Type) }
    },
    draftValidation: {
        approvalBy: function (value) { return this.get('configuration').DisplayApprovalNeededBy && !value ? (Labels.ErrorMsg.replace('{0}', Labels.ApprovalNeededBy)) : ''; }
    },
    deleteReasonValidation: {
        deleteReason: { required: true, msg: Labels.ErrorMsg.replace('{0}', Labels.Reason) }
    }
});

module.exports.Records = Backbone.Collection.extend({
    model: module.exports.Record,
    url: API + 'Record'
});

module.exports.RecordNotification = Backbone.Model.extend({
    defaults: {
        _id: '',
        accountingStandard: '',
        approvalBy: '',
        auditClient: '',
        approvers: [],
        clientName: '',
        configuration: {},
        closeMonitoring: '',
        completedOn: '',
        countryId: '//',
        createdBy: '',
        createdOn: '',
        creatorGivenName: '',
        engagementId: '',
        engagementName: '',
        expiryAt: new Date(),
        fiscalYearEnd: '',
        geographyId: '//',
        geographyTypePath: '',
        industry: '',
        engagementValidated: false,
        link: '',
        listedEntity: '',
        nonListedPie: '',
        partner: '',
        recordTypeId: '',
        restricted: '',
        secRegistrant: '',
        statusTypeId: 'StatusType_Blank',
        statusResourceKey: '',
        subject: '',
        subtype: '',
        type: '',
        validateEngagement: true
    },
    urlRoot: API + 'RecordNotification'
});

module.exports.NotificationRecords = Backbone.Collection.extend({
    model: module.exports.RecordNotification,
    url: API + 'RecordNotification'
});

module.exports.Role = Backbone.Model.extend({
    defaults: {
        geographyId: '//',
        geographyTypePath: '//',
        roleId: '',
        specialty: ''
    },
    validation: {}
});

module.exports.Roles = Backbone.Collection.extend({
    model: module.exports.Role
});

module.exports.Solr = Backbone.Model.extend({
    defaults: {
        documentId: '',
        formData: '',
        key: ''
    },
    urlRoot: SolrAPI
});

module.exports.SolrSearch = Backbone.Model.extend({

    urlRoot: SolrAPI + 'Search'
});

module.exports.User = Backbone.Model.extend({
    defaults: {
        _id: '',
        active: true,
        adStatus:true,
        deletedRoles: [],
        displayName: '',
        preferences: {},
        geography: '//',
        givenName: '',
        email: '',
        physicalDeliveryOfficeName: '',
        roles: [],
        upn: '',
        gpn:'',
        privacyAck: false,
        privacyAckDate: '',
        privacyAckVersion: ''
    },
    urlRoot: API + 'User'
});

module.exports.Users = Backbone.Collection.extend({
    model: module.exports.User,
    url: API + 'User'
});

module.exports.DeleteRecordJob = Backbone.Model.extend({
    defaults:{
        date:'',
        isJobExecuted: false,
        api:''
    },
    urlRoot:API+'DeleteRecordJob'
});

module.exports.DeleteRecordJobs = Backbone.Collection.extend({
    model:module.exports.DeleteRecordJob,
    url:API+'DeleteRecordJob'
});


// WEBPACK FOOTER //
// ./js/Modules/Application/Entities.js